import {ChangeDetectionStrategy, Component, ElementRef, input, signal, viewChild} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {TranslateModule} from "@ngx-translate/core";
import {animate, query, stagger, state, style, transition, trigger} from '@angular/animations';
import {takeUntilDestroyed, toObservable} from "@angular/core/rxjs-interop";
import {fromEvent, Observable, switchMap} from "rxjs";
import {leverForsinketMedMindreAnnenStrømLeverer} from "felles-ng2/støttefunksjoner/observable";

const debug = initDebugger('FabMenyKomponent');


/**
 * Flytende ikon-basert meny
 */
@Component({
    selector: 'fab-meny',
    templateUrl: 'fab-meny.html',
    styleUrl: 'fab-meny.scss',
    host: {'data-testid': 'fab-meny'},
    animations: fabAnimasjoner(),
    exportAs: 'fabMeny',
    imports: [
        MatIcon,
        TranslateModule,
        MatIconButton
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FabMenyKomponent {

    protected kontainer = viewChild.required('kontainer', {read: ElementRef});

    /** Dersom sann vises ikke menyinnslagene */
    menyinnslagDeaktivert = input(false);

    protected aktivert = signal(false);

    constructor() {
        const musInnEvent = this.lyttTilKontainerHendelse('mouseenter');
        const musUtEvent = this.lyttTilKontainerHendelse('mouseleave')
          .pipe(leverForsinketMedMindreAnnenStrømLeverer(100, musInnEvent), takeUntilDestroyed());

        musUtEvent.subscribe(() => this.deaktiver())
        musInnEvent.subscribe(() => this.aktiver())
    }

    toggle(aktivert?: boolean) {
        const nyTilstand = aktivert ?? !this.aktivert();
        nyTilstand ? this.aktiver() : this.deaktiver();
    }

    aktiver() {
        this.aktivert.set(true);
    }

    deaktiver() {
        this.aktivert.set(false);
    }

    //private hjelpemetoder

    private lyttTilKontainerHendelse(hendelse: string): Observable<MouseEvent> {
        return toObservable(this.kontainer)
          .pipe(switchMap(knapp => fromEvent<MouseEvent>(knapp.nativeElement, hendelse)), takeUntilDestroyed());
    }
}


function fabAnimasjoner() {
    return [
        //animerer rotasjon av + i fab-trigger
        trigger('fabTrigger', [
            //når fab-meny vises
            state('false', style({transform: 'rotate(0deg)'})),
            //når fab-meny skjules
            state('true', style({transform: 'rotate(225deg)'})),
            transition('* <=> *', animate('200ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
        //animerer visning button-elementene i fab-menyen slik at disse fader/sklir inn og ut
        trigger('fadMeny', [
            //når .kontainer (fab-menyen) vises
            transition(':enter', [
                //anvend animasjonen på alle 'button' elementer som er barn av fab-menyen
                    query('button', [
                        style({opacity: 0, transform: 'translateX(-10px)'}),
                        //stagger sørger for at animering av de enkelte knappene skjer sekvensielt (animasjon av andre knapp starter etter at animasjon av første er ferdig etc.)
                        stagger('50ms', [animate('200ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({opacity: 1, transform: 'translateX(0)'}))])
                    ])
            ]),
            //når .kontainer (fab-menyen) skjules
            transition(':leave', [
                query('button', [
                    style({opacity: 1, transform: 'translateX(0)'}),
                    //negativ verdi til stagger sørger for at animasjonen starter med siste element (button) i steden for første
                    stagger('-50ms', [animate('200ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({opacity: 0, transform: 'translateX(-10px)'}))])
                ])
            ])
        ])
    ];
}
